<pcg-table 
	#table 
	class="card-table"
	[ajaxData]="filters" 
	[pcgSort]='[[ "dateChanged", "desc" ]]'
	dataSource='api/Administration/Users/GetUserAuditHistory' 
	[columnDefs]="columns"
	(tableReceive)="fullName = $event.value"
	[canExportTableToExcel]="true"
>

	<ng-container matColumnDef="dateChanged">
		<th 
            mat-header-cell 
            pcg-sort-header 
            *matHeaderCellDef
        >{{ columns.get('dateChanged').displayName }}</th>
		<td 
            mat-cell 
            *matCellDef='let row' 
            [attr.data-label]="columns.get('dateChanged').displayName"
        >{{ row.dateChangedFormatted }}</td>
	</ng-container>

	<ng-container matColumnDef="field">
		<th 
            mat-header-cell 
            pcg-sort-header 
            *matHeaderCellDef
        >{{ columns.get('field').displayName }}</th>
		<td 
            mat-cell 
            *matCellDef='let row' 
            [attr.data-label]="columns.get('field').displayName"
        >{{ row.field }}</td>
	</ng-container>

	<ng-container matColumnDef="changedFrom">
		<th 
            mat-header-cell 
            pcg-sort-header 
            *matHeaderCellDef
        >{{ columns.get('changedFrom').displayName }}</th>
		<td 
            mat-cell 
            *matCellDef='let row' 
            [attr.data-label]="columns.get('changedFrom').displayName"
        >{{ row.changedFrom }}</td>
	</ng-container>

	<ng-container matColumnDef="changedTo">
		<th 
            mat-header-cell 
            pcg-sort-header 
            *matHeaderCellDef
        >{{ columns.get('changedTo').displayName }}</th>
		<td 
            mat-cell 
            *matCellDef='let row' 
            [attr.data-label]="columns.get('changedTo').displayName"
        >{{ row.changedTo }}</td>
	</ng-container>

	<ng-container matColumnDef="changedBy">
		<th 
            mat-header-cell 
            pcg-sort-header 
            *matHeaderCellDef
        >{{ columns.get('changedBy').displayName }}</th>
		<td 
            mat-cell 
            *matCellDef='let row' 
            [attr.data-label]="columns.get('changedBy').displayName"
        >{{ row.changedBy }}</td>
	</ng-container>

</pcg-table>